import { formatDate } from '../../utils/dateFormat';

const esc = (v) => String(v ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const d = (v) => (v && /^\d{4}-\d{2}-\d{2}$/.test(v) ? formatDate(v) : v || '');
const LABELS = ['Initial Contact', 'Contact 2', 'Contact 3', 'Contact 4'];

const contactHtml = (r, n) => {
  if (r.locked_from != null && n > r.locked_from) return '<em>Unavailable</em>';
  const c = (r.contacts || []).find((x) => x.n === n);
  if (!c) return '';
  return `${esc(c.assigned_user_name || 'Unassigned')}<br>${esc(d(c.date))}<br><b>${esc(c.status || '')}</b>`;
};

export const printReferrals = (records, title, subtitle) => {
  const head = ['Referral Date', 'County', 'Referral Type', 'First Name', 'Last Name', 'Case Number', 'ABAWD Status', 'Certification Period', 'Email', ...LABELS];
  const rows = records.map((r) => {
    const cert = r.certification_start || r.certification_end ? `${d(r.certification_start)} – ${d(r.certification_end)}` : r.certification_period || '';
    const cells = [d(r.referral_date), r.county, r.referral_type, r.first_name, r.last_name, r.case_number, r.abawd_status, cert, r.email].map(esc);
    return `<tr>${cells.map((c) => `<td>${c}</td>`).join('')}${[1, 2, 3, 4].map((n) => `<td>${contactHtml(r, n)}</td>`).join('')}</tr>`;
  }).join('');
  const printed = new Date().toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short', hour12: true });
  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.write(`<!doctype html><html><head><title>${esc(title)}</title><style>
    @page { size: landscape; margin: 0.4in; }
    body { font-family: Arial, sans-serif; font-size: 9px; color: #222; }
    h1 { font-size: 16px; color: #92298d; margin: 0 0 2px; } p { margin: 0 0 10px; color: #555; }
    table { border-collapse: collapse; width: 100%; } th { background: #92298d; color: #fff; text-align: left; }
    th, td { border: 1px solid #ccc; padding: 3px 4px; vertical-align: top; } tr:nth-child(even) td { background: #f7f7f7; }
    thead { display: table-header-group; }
  </style></head><body><h1>${esc(title)}</h1><p>${esc(subtitle)} · ${records.length} referral(s) · Printed ${esc(printed)}</p>
  <table><thead><tr>${head.map((h) => `<th>${h}</th>`).join('')}</tr></thead><tbody>${rows}</tbody></table></body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 300);
  return true;
};
